import {StudyContent} from '@cp/model';
import {env} from '../../../../config/env';

/**
 * Combines an array of StudyContent items into a single markdown content string.
 * Each StudyContent item is converted to:
 * - A ## header with the title
 * - The content text
 * - An optional plotly code block if graphJson is present
 *
 * @param studyContent - Array of StudyContent items to combine
 * @returns Combined markdown content string
 */
export default function mapStudyContentToContent(studyContent: StudyContent | null | undefined): string {
  if (!studyContent) {
    return '';
  }

  const parts: string[] = [];

  parts.push(`${env.study.separator}${studyContent.title || ''}`);

  if (studyContent.content) {
    parts.push(studyContent.content);
  }

  return parts.join('\n');
}
